import request from '@/config/request.js'
import {downloadFileAll} from '@/config/api/common.js'
import setting from '@/config/settings'
const ApiEvaluation = request.FileDowm
import common from '@/components/common/'
import pdf from 'vue-pdf'
export default {
  components: {
    ...common,
    pdf
  },
  name: 'upload-list',
  data () {
    return {
      fileDownLoadUrl: setting.gbs.fileDownLoad,
      appUrl: setting.gbs.host,
      qiniu: setting.gbs.qiniu,
      search_data: {
        filters: [{
          field: 'fileName',
          operator: 'like',
          value: ''
        }, {
          field: 'isEnable',
          operator: 'eq',
          value: true
        }, {
          field: 'fileDirectory',
          operator: 'eq',
          value: ''
        }, {
          field: 'del',
          operator: 'eq',
          value: false
        }],
        current_page: 1,
        total: 0,
        page_size: 10,
      },
      tableList: [],
      selected: [],   // 存储所有选中的数据
      status: [
        {
          name: '已使用',
          value: true
        },
        {
          name: '未使用',
          value: false
        }
      ],
      myHeaders: { Authorization: this.$store.state.login.token },
      formLabelWidth: '120px',
      uploadDailog: false,
      uploadDetails: {
        paperName: '',
        categoryPath: '',
        paperUrl: '',
        categoryPath2: '',
        size: '',
        suffix: ''
      },
      rules: {
        uploadUrl: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ]
      },
      fileList: [],
      treeData: [
        {
          directoryId: '-1',
          directoryName: '全部资料',
          children: []
        }
      ],
      defaultShowNodes: ['-1'],
      defaultProps: {
        label: 'title',
        isLeaf: 'isLeaf'
      },
      checkNodes: [],
      treeDailog: false,
      treeEditDailog: false,
      treeEditFrom: {
        directoryId: '',
        directoryName: ''
      },
      treeNodeFrom: {
        parentId: '',
        directoryName: ''
      },
      rows: [],
      uploadList: [],
      btnLoading: false,
      totalFiles: 0,
      successfulUploads: 0,
      failedUploads: 0,
      uploading: [],
      pdfUrl: '',
      pdfView: false,
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      imgView: false,
      imgUrl: '',
      downLoading: false,
      fileDownId: '',
      textToCopy: '',
      btn_loading: false,
      parentChain: [],
      isLeaf: false,
      loadingTable: false,
      fileSize: 0
      
    }
  },
  // 默认认展开一级
  // watch: {
  //   treeData: {
  //     handler() {
  //       this.treeData.forEach((item) => {
  //         this.defaultShowNodes.push(item.directoryId);
  //       });
  //     },
  //     deep: true,
  //   },
  // },
  computed: {
    tableHight: function () {
      return window.innerHeight - 330
    },
    loading: function () {
      return this.$store.state.global.ajax_loading
    },
    maxSpaceBytes: function () {
      return 1 * 1024 * 1024 * 1024
    },
    usedSpaceBytes: function () {
      return this.parseSizeToBytes(this.fileSize)
    },
    spacePercent: function () {
      const total = this.maxSpaceBytes
      // console.log(total)
      const used = this.usedSpaceBytes
      // console.log(used)
      if (!total) return 0
      const n = (used / total) * 100
      if (!isFinite(n)) return 0
      console.log(n, Math.max(0, Math.min(100, Math.round(n))))
      return Math.max(0, Math.min(100, Math.round(n)))
    },
    fileSizeDisplay: function () {
      if (typeof this.fileSize === 'string') return this.fileSize.trim()
      if (typeof this.fileSize === 'number') return this.formatBytes(this.fileSize)
      return ''
    }
  },
  methods: {
    parseSizeToBytes (val) {
      if (val == null) return 0
      if (typeof val === 'number') return val >= 0 ? val : 0
      const raw = String(val).trim()
      if (!raw) return 0
      const s = raw.replace(/\s+/g, '').toUpperCase()
      const m = s.match(/^(\d+(?:\.\d+)?)([A-Z]+)?$/)
      if (!m) return 0
      const num = Number(m[1])
      if (!isFinite(num) || num < 0) return 0
      const unit = m[2] || 'B'
      const map = {
        B: 1,
        BYTE: 1,
        BYTES: 1,
        K: 1024,
        KB: 1024,
        M: 1024 * 1024,
        MB: 1024 * 1024,
        G: 1024 * 1024 * 1024,
        GB: 1024 * 1024 * 1024,
        T: 1024 * 1024 * 1024 * 1024,
        TB: 1024 * 1024 * 1024 * 1024
      }
      const mul = map[unit]
      if (!mul) return 0
      return Math.round(num * mul)
    },
    formatBytes (bytes) {
      const n = Number(bytes)
      if (!isFinite(n) || n <= 0) return '0B'
      const KB = 1024
      const MB = 1024 * 1024
      const GB = 1024 * 1024 * 1024
      if (n >= GB) return (n / GB).toFixed(2) + 'GB'
      if (n >= MB) return (n / MB).toFixed(2) + 'MB'
      if (n >= KB) return (n / KB).toFixed(2) + 'KB'
      return String(Math.round(n)) + 'B'
    },
    downloadZip() {
      if (this.rows.length < 1) {
        this.$message.error(`请勾选需要导出的数据`);
        return
      }

      this.btn_loading = true
      let arr = []
      this.rows.map(item => {
        arr.push({
          fileId: item.fileId,
          fileUrl: item.fileUrl
        })
      });

      downloadFileAll(arr, {
        responseType: 'blob' // 关键配置
      }).then(res => {
        const responseData = res.data || res;
        let blob;
        if (responseData instanceof Blob) {
          blob = new Blob([responseData], { type: 'application/zip' });
        } else {
          blob = new Blob([responseData], { type: 'application/json' });
          console.error('接口未返回Blob数据，实际响应:', responseData);
          throw new Error('服务器返回了非ZIP文件数据');
        }
        const objectUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = objectUrl;

        const fileName = this.parseFileName(res.headers) || '全部文件.zip';
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);
          this.$nextTick(() => {
            this.btn_loading = false
          })
        }, 100);
      }).catch(error => {
        this.btn_loading = false
        console.error('下载失败:', error);
        this.$message.error(`下载失败: ${error.message}`);

      });

    },

// 从响应头解析文件名
    parseFileName() {
      // this.parentChain.map
      let str = ''
      for (let i = 0; i < this.parentChain.length; i++) {
        if (i == 0) {
          str = '【' + this.parentChain[i].title + '】'
        } else {
          str += ('-' + this.parentChain[i].title)
        }
      }
      return str+'.zip'
    },
    loadNode(node, resolve) {
      // resolve([])
      if (node.level === 0) {
        ApiEvaluation.getTree.call(this, {}, (listData) => {
          return resolve(listData);
        })
      } else {
        ApiEvaluation.getChildFileDirectoryTreeItems.call(this, {directoryId: node.data.key}, (listData) => {
          return resolve(listData);
        })
      }

      /*setTimeout(() => {
        const data = [{
          name: 'leaf',
          leaf: true
        }, {
          name: 'zone'
        }];

        resolve(data);
      }, 500);*/
    },
    closePdfView () {
      this.pdfUrl = ''
      this.pdfView = false
    },
    getView (row) {
      const url = this.qiniu + decodeURI(encodeURI(row.filePath))
      this.downUrl = url
      // console.log(url, 'url')
      // return
      if (/\.(doc|docx|ppt|pptx|xls|xlsx)$/.test(url)) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), '_blank'
        )
        return false
      }  else if (/\.(jpg|jpge|png)$/.test(url)) {
        this.imgUrl = url
        this.imgView = true
      } else if (/\.(pdf)$/.test(url)) {
        this.pdfUrl = url
        console.log(url, 'pdf')
        this.pdfView = true
      } else {
        window.open(url)
      }
    },
    async getCopy (row) {
      const url = this.qiniu + row.filePath
      /*try {
        await navigator.clipboard.writeText(url+ '?' +  row.fileName);
        this.$message.success('复制成功！');
        ApiEvaluation.addFileDownloadNum.call(this, row, (listData) => {
          // this.initData()
        })
      } catch (error) {
        this.$message.error('复制失败：' + error);
      }*/
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.value = url+ '?' +  row.fileName;
      input.focus();
      input.select();
      try {
        const result = document.execCommand('copy');
        document.body.removeChild(input);
        if (!result) {
          console.error('复制失败');
        } else {
          this.$message.success('复制成功');
        }
      } catch (e) {
        document.body.removeChild(input);
        this.$message.error('当前浏览器不支持复制功能，请检查更新或更换其他浏览器操作');
      }

    },
    getDown (row) {
      const url = this.qiniu + row.filePath
      window.open(url + '?attname=' +  encodeURIComponent(row.fileName)+'.'+(row.fileType).toLowerCase())
      // ApiEvaluation.addFileDownloadNum.call(this, row, (listData) => {
      //   this.initData()
      // })
      /*let link = document.createElement('a')
      let url = this.qiniu + decodeURI(encodeURI(row.fileUrl))*/
      // 这里是将url转成blob地址，
      /*const elink = document.createElement("a");
      elink.download = row.fileName;
      elink.style.display = "none";
      elink.href = 'https://angelbell.anqinyun.com/fmp/ZSXSK/20220428/313/%E3%80%8A%E6%AF%8D%E4%BA%B2%E8%8A%82%E6%B4%BB%E5%8A%A8%E6%B5%B7%E6%8A%A5%E3%80%8B.zip'
      // URL.createObjectURL(blob);
      elink.setAttribute('download', row.fileName + '.' + row.fileFormat);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href);
      document.body.removeChild(elink);*/
      /*fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = row.fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob)
          // URL.createObjectURL(blob);
          elink.setAttribute('download', row.fileName + '.' + row.fileFormat);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, row.fileName);
        }
        // let url = window.URL.createObjectURL(blob);
        // window.open(url, '_blank');



        /!*link.href = URL.createObjectURL(blob)
        console.log(link.href)
        // link.download = ''
        link.setAttribute('download', row.fileName + '.' + row.fileFormat);
        document.body.appendChild(link)
        link.click()*!/
        ApiEvaluation.addFileDownloadNum.call(this, row, (listData) => {
          this.initData()
        })
      })*/
     /* const url = this.qiniu + decodeURI(encodeURI(row.fileUrl));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', row.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);*/
      // link.download = row.fileName + '.' + row.fileFormat;

      // 发起 fetch 请求，获取文件内容
      /*fetch(url)
        .then(response => response.blob())
        .then(blob => {
          // 创建临时链接
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', row.fileName);
          document.body.appendChild(link);
          // 触发点击事件下载文件
          link.click();
          document.body.removeChild(link);
          this.$message({
            type: 'success',
            message: '下载成功，请等待!'
          })

          ApiEvaluation.addFileDownloadNum.call(this, row, (listData) => {
            this.initData()
          })
         /!* this.downLoading = false
          this.fileDownId = ''*!/
          // 释放临时链接
          URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          // this.downLoading = false
          // this.fileDownId = ''
          console.error('文件下载出错:', error);
        });*/
    },
    getFileType (row) {
      const url = this.qiniu + decodeURI(encodeURI(row.filePath))
      
      const verifyFile = /.(doc|docx|ppt|pptx|xls|xlsx|jpg|jpge|png|pdf)$/i
      if (verifyFile.test(url)) {
        return true
      } else {
        return false
      }
    },
    // 上一页
    prePage () {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    initFileSize () {
      ApiEvaluation.getTotalCalendarFavoriteSize.call(this, {}, (listData) => {
        this.fileSize = listData.totalSize
      })
    },
    // 下一页
    nextPage () {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    initData () {
      var data = {
        offset: (this.search_data.current_page - 1) * this.search_data.page_size,
        limit: this.search_data.page_size,
        data: {},
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'id'
      }
      // data = Object.assign(data, ({
      //   filters: this.search_data.filters.filter(item => {
      //     if (item.value !== '') {
      //       return item
      //     }
      //   })
      // } || {}))
      this.loadingTable = true
      ApiEvaluation.pageCalendarFavoriteDetails.call(this, data, (listData) => {
        this.tableList = listData.content
        this.search_data.total = parseInt(listData.totalElements)

        this.loadingTable = false
        // this.$nextTick(() => {
        //   this.tableList.forEach(row => {
        //     const isSelected = this.rows.some(item => item.fileId === row.fileId);
        //     this.$refs.table.toggleRowSelection(row, isSelected);
        //   });
        // });
      })
    },
    // 处理选中变化
    handleSelectionChange (val) {
      this.rows = val
    },
    onDeleteFiles (row) {
     this.$confirm('确定删除收藏文件吗？ 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ApiEvaluation.deleteCalendarFavorite.call(this, {
            id: row.id
          }, res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.onSearch()
          })
        })
    },
    
    resetTable () {
      this.search_data.filters[0].value = ''
      this.initData()
    },
    /**
     * 搜索事件
     */
    onSearch () {
      this.search_data.current_page = 1
      this.initData()
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.search_data.current_page = page
      this.initData()
    },
    getTree () {
      ApiEvaluation.getTree.call(this, {}, (listData) => {
        this.treeData[0].children = listData
      })
    }
  },
  mounted () {
    // this.getTree()
    this.initData()
    this.initFileSize()
  }
}
